/**
 * Multi-Range-Push Presets — Vorlagen die User mit 1 Klick in die Tabelle laden koennen.
 *
 * Aktuell: "Saison-Variation" — realistisches Initial-Setup mit Saison-Preisen + Sperre.
 * Vermeidet Flat-100€-Pattern beim Erst-Push.
 */
import { newMultiRangeRow, type MultiRangeRow } from './multiRangeRowModel';

export interface PresetDefinition {
  id: string;
  label: string;
  description: string;
  build: () => MultiRangeRow[];
}

function daysFromToday(offset: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + offset);
  return d.toISOString().slice(0, 10);
}

function row(patch: Partial<MultiRangeRow>): MultiRangeRow {
  return { ...newMultiRangeRow(), ...patch };
}

export const MULTI_RANGE_PRESETS: PresetDefinition[] = [
  {
    id: 'season-variation',
    label: 'Saison-Variation (500 Tage)',
    description:
      'Verschiedene Preise + Min-Stay pro Saison-Block. Realistisches Pattern statt flat-Preis.',
    build: () =>
      buildSorted([
        row({
          from: daysFromToday(1),
          to: daysFromToday(60),
          rate: '120.00',
          availability: 'available',
          minStay: '2',
        }),
        row({
          from: daysFromToday(61),
          to: daysFromToday(120),
          rate: '140.00',
          availability: 'available',
          minStay: '2',
        }),
        row({
          from: daysFromToday(121),
          to: daysFromToday(180),
          rate: '180.00',
          availability: 'available',
          minStay: '3',
        }),
        // Maintenance-Block mitten in der Saison — ueberschreibt Range 3 fuer diese 5 Tage
        // (Last-Wins-Pattern in Multi-Range-Pushes).
        row({ from: daysFromToday(175), to: daysFromToday(179), availability: 'blocked' }),
        row({
          from: daysFromToday(181),
          to: daysFromToday(240),
          rate: '160.00',
          availability: 'available',
          minStay: '2',
        }),
        row({
          from: daysFromToday(241),
          to: daysFromToday(300),
          rate: '200.00',
          availability: 'available',
          minStay: '3',
        }),
        row({
          from: daysFromToday(301),
          to: daysFromToday(360),
          rate: '240.00',
          availability: 'available',
          minStay: '4',
        }),
        row({
          from: daysFromToday(361),
          to: daysFromToday(420),
          rate: '150.00',
          availability: 'available',
          minStay: '2',
        }),
        row({
          from: daysFromToday(421),
          to: daysFromToday(500),
          rate: '175.00',
          availability: 'available',
          minStay: '2',
        }),
      ]),
  },
];

// Chronologisch nach From-Datum sortieren — UI-Reihenfolge soll der Zeitachse folgen.
// Bei gleichem From: kuerzere Range zuerst, damit Maintenance-Bloecke oben stehen.
function buildSorted(rows: MultiRangeRow[]): MultiRangeRow[] {
  return [...rows].sort((a, b) => {
    if (a.from !== b.from) return a.from.localeCompare(b.from);
    return a.to.localeCompare(b.to);
  });
}

export function presetById(id: string): PresetDefinition | undefined {
  return MULTI_RANGE_PRESETS.find((p) => p.id === id);
}
